var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("🏛")]), _vm._v(" "), _vm._l((_vm.landmarks), function(landmark, index) {
    return [(index != _vm.landmarksCount - 1) ? _c('span', {
      key: index
    }, [_c('i', [_vm._v(_vm._s(landmark))]), _vm._v(",\n    ")]) : _c('span', {
      key: index
    }, [_vm._v("\n      and\n      "), _c('i', [_vm._v(_vm._s(landmark))]), _vm._v(".\n    ")])]
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ef46bca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandmarksList.vue
// module id = 13Ov
// module chunks = 1